<div id="openseadragonViewer" [ngClass]="modal ? 'modal' : 'image-view'"></div>
